import React, { useLayoutEffect, useRef } from 'react';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
var t = i18n.getFixedT(null, 'stats-dashboard');
var statsZonesChart = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      statsZones = _useSelector.statsDashboard.statsZones;

  var chartXY = useRef();
  var categoryAxis = useRef();
  if (statsZones == 'noData') return /*#__PURE__*/React.createElement("div", {
    className: "statsZonesChart-nodata"
  }, t('lbl-no-data'));
  useLayoutEffect(function () {
    chartXY.current = am4core.create('statsZonesChart', am4charts.XYChart);
    am4core.addLicense;
    chartXY.current.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chartXY.current.cursor = new am4charts.XYCursor(); // Create axes

    categoryAxis.current = chartXY.current.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.current.dataFields.category = 'zoneName';
    categoryAxis.current.renderer.grid.template.location = 0;
    categoryAxis.current.renderer.minGridDistance = 0;
    categoryAxis.current.renderer.cellStartLocation = 0.2;
    categoryAxis.current.renderer.cellEndLocation = 0.8; // disable xAxes tooltip

    categoryAxis.current.cursorTooltipEnabled = false; // Configure axis label

    var label = categoryAxis.current.renderer.labels.template;
    label.truncate = false;
    label.maxWidth = 100; // label.tooltipText = "{category}"

    categoryAxis.current.events.on("sizechanged", function (ev) {
      var axis = ev.target;
      var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);

      if (cellWidth < axis.renderer.labels.template.maxWidth) {
        axis.renderer.labels.template.fontSize = 13;
        axis.renderer.labels.template.rotation = -45;
        axis.renderer.labels.template.horizontalCenter = "right";
        axis.renderer.labels.template.verticalCenter = "middle";
        axis.renderer.labels.template.dx = 15;
        axis.renderer.labels.template.dy = -15;
      } else {
        axis.renderer.labels.template.fontSize = 15;
        axis.renderer.labels.template.rotation = 0;
        axis.renderer.labels.template.horizontalCenter = "middle";
        axis.renderer.labels.template.verticalCenter = "top";
        axis.renderer.labels.template.dx = 0;
        axis.renderer.labels.template.dy = 0;
      }
    });
    var valueAxis = chartXY.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minGridDistance = 30;
    valueAxis.min = 0;
    valueAxis.cursorTooltipEnabled = false; // Set up series

    var series = chartXY.current.series.push(new am4charts.ColumnSeries());
    series.name = '進口';
    series.dataFields.valueY = 'entryCount';
    series.dataFields.categoryX = "zoneName";
    series.sequencedInterpolation = true;
    series.columns.template.strokeWidth = 0;
    series.columns.template.width = am4core.percent(100); // tooltip coordinate

    series.columns.template.tooltipX = am4core.percent(100);
    series.columns.template.tooltipY = am4core.percent(0);
    series.columns.template.adapter.add('tooltipText', function (text, target) {
      var _target$tooltipDataIt = target.tooltipDataItem.dataContext,
          entryCount = _target$tooltipDataIt.entryCount,
          exitCount = _target$tooltipDataIt.exitCount,
          zoneName = _target$tooltipDataIt.zoneName;
      target.tooltip.getFillFromObject = false;
      target.tooltip.background.fill = am4core.color("#000");
      var entryText = "\u9032\u53E3: ".concat(entryCount);
      var exitText = "\u51FA\u53E3: ".concat(exitCount);
      return "".concat(zoneName, "\n").concat(entryText, "\n").concat(exitText);
    });
    var series2 = chartXY.current.series.push(new am4charts.ColumnSeries());
    series2.name = '出口';
    series2.dataFields.valueY = 'exitCount';
    series2.dataFields.categoryX = "zoneName";
    series2.sequencedInterpolation = true;
    series2.columns.template.strokeWidth = 0;
    series2.columns.template.width = am4core.percent(100); // Configure columns
    // series.columns.template.width = am4core.percent(60)
    // series.columns.template.tooltipText = `{valueY}${type==='termanal' ? '輛' : '分'}`
    // Add label

    var labelBullet = series.bullets.push(new am4charts.LabelBullet()); // labelBullet.label.text = "{valueY}"

    labelBullet.locationY = 0.5;
    labelBullet.label.hideOversized = true; // Add a legend

    chartXY.current.legend = new am4charts.Legend();
    chartXY.current.legend.position = 'right';
    chartXY.current.legend.maxWidth = '100';
    chartXY.current.legend.fontSize = '12';
    chartXY.current.data = _.map(statsZones, function (el) {
      return {
        zoneName: el.zoneName,
        entryCount: el.entryCount,
        exitCount: el.exitCount
      };
    }); // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chartXY.current.dispose();
    };
  }, [JSON.stringify(statsZones)]);
  return /*#__PURE__*/React.createElement("div", {
    id: "statsZonesChart"
  });
});
export default statsZonesChart;